export default __webpack_public_path__ + "static/media/iphone.86f198db.jpg";